import { render, staticRenderFns } from "./ProductTagForm.vue?vue&type=template&id=0ecf6a77&"
import script from "./ProductTagForm.vue?vue&type=script&lang=js&"
export * from "./ProductTagForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ecf6a77')) {
      api.createRecord('0ecf6a77', component.options)
    } else {
      api.reload('0ecf6a77', component.options)
    }
    module.hot.accept("./ProductTagForm.vue?vue&type=template&id=0ecf6a77&", function () {
      api.rerender('0ecf6a77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/carnival/orderMgt/modules/ProductTagForm.vue"
export default component.exports